import { render } from "./KariirekinSettingLongItem.vue?vue&type=template&id=757df564&ts=true"
import script from "./KariirekinSettingLongItem.vue?vue&type=script&lang=ts"
export * from "./KariirekinSettingLongItem.vue?vue&type=script&lang=ts"

import "./KariirekinSettingLongItem.vue?vue&type=style&index=0&id=757df564&lang=scss"

import exportComponent from "D:\\02_システム\\20_帳票テンプレート\\02_開発\\report-template\\web-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__